import { Component, OnInit } from '@angular/core';
import { AnalyticEvent, AnalyticsBloc, AnalyticsPageName } from '@kanalytics';
import { OnboardingBloc } from '@kp/onboarding/onboarding.bloc';
import { WorkbookBloc } from '@kp/workbook/workbook.bloc';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'kp-screen-workbook-promo',
  templateUrl: './screen-workbook-promo.component.html',
  styleUrls: ['./screen-workbook-promo.component.scss'],
})
export class ScreenWorkbookPromoComponent implements OnInit {
  declineLink = this._deviceDetectorService.isDesktop()
    ? '/welcome/mobile-app/interstitial'
    : '/welcome/mobile-app/interstitial/mobile';

  constructor(
    private _analyticsBloc: AnalyticsBloc,
    private _deviceDetectorService: DeviceDetectorService,
    public onboardingBloc: OnboardingBloc,
    private _workbookBloc: WorkbookBloc
  ) {}

  ngOnInit() {
    this._analyticsBloc.sendEvent(
      this._analyticsBloc.createEventFromInteraction({
        page: AnalyticsPageName.workbook,
        event: AnalyticEvent.workbook_promo_shown,
      })
    );
  }

  declineWorkbook() {
    this._workbookBloc.declineWorkbook();
    this._analyticsBloc.sendEvent(
      this._analyticsBloc.createEventFromInteraction({
        page: AnalyticsPageName.workbook,
        event: AnalyticEvent.workbook_order_declined,
      })
    );
  }
}
